import React, { useState, useRef } from "react";
import Terminal from "./terminal";

const ApplicationForm = ({ role }) => {

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);

  const buttonRef = useRef(null);

  const [formData, setFormData] = useState({
    role: role,
    name: "",
    email: "",
    phone: "",
    linkedin: "",
    message: "",
  });

  const [message, setMessage] = useState("");

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const hasValue = (value) => value.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { role, name, email, phone, linkedin, message } = formData;

    const newErrors = {};
    if (!hasValue(role)) newErrors.role = true;
    if (!hasValue(name)) newErrors.name = true;
    if (!validateEmail(email)) newErrors.email = true;
    if (!hasValue(phone)) newErrors.phone = true;
    if (!hasValue(linkedin)) newErrors.linkedin = true;
    if (!hasValue(message)) newErrors.message = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSubmitSuccess(false);
      setMessage("Ditt ansökan har inte skickats.\n\nSäkerställ att de obligatoriska fälten är ifyllda korrekt.");
      return;
    }

    const data = {
      name: formData.name,
      role: formData.role,
      email: formData.email,
      phone: formData.phone,
      linkedin: formData.linkedin,
      message: formData.message
    };


    try {
      await fetch("https://api.dev.acebit.se/job_application/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      setSubmitSuccess(true);
      setMessage("Din ansökan har skickats!");
      setErrors({});
    } catch (error) {
      setSubmitSuccess(false);
      setMessage("Ett fel inträffade när meddelandet skickades.\n\nFörsök igen senare.");
    }
  };

  return (
    <>
      <button
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        onClick={openModal}
        ref={buttonRef}
      >
        Ansök
      </button>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md" onClick={() => setIsOpen(false)}>
          <div className="sm:w-1/4 w-5/6" onClick={(e) => e.stopPropagation()}>
            <Terminal title="application">

              {submitSuccess ? <div className="flex">{message}</div> :
                <form id="application-form" className="flex flex-col gap-2" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    value={formData.role}
                    readOnly
                    className="p-2 dark:bg-gray-800 bg-slate-300 autofill:bg-gray-800"
                  />
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className={`p-2 dark:bg-gray-800 bg-slate-300 ${errors.name ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className={`p-2 dark:bg-gray-800 bg-slate-300 ${errors.email ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="text"
                    name="phone"
                    placeholder="Telefon"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className={`p-2 dark:bg-gray-800 bg-slate-300 ${errors.phone ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="text"
                    name="linkedin"
                    placeholder="LinkedIn"
                    value={formData.linkedin}
                    onChange={handleChange}
                    required
                    className={`p-2 dark:bg-gray-800 bg-slate-300 ${errors.linkedin ? "border-2 border-red-500" : ""}`}
                  />
                  <textarea
                    name="message"
                    placeholder="Meddelande"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className={`min-h-28 resize-none p-2 dark:bg-gray-800 bg-slate-300 ${errors.linkedin ? "border-2 border-red-500" : ""}`}
                  />
                  <div className="w-full">
                    <button type="submit" className="text-black bg-sky-500 hover:bg-sky-700 focus:ring-4 w-full min-w-10 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-sky-500 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                      Skicka
                    </button>
                  </div>
                </form>
              }
            </Terminal>
          </div>
        </div>
      )}
    </>
  );
};


export default ApplicationForm;